import { render, staticRenderFns } from "./MisPostulaciones.vue?vue&type=template&id=0ff9139c&scoped=true&"
import script from "./MisPostulaciones.vue?vue&type=script&lang=js&"
export * from "./MisPostulaciones.vue?vue&type=script&lang=js&"
import style0 from "./MisPostulaciones.vue?vue&type=style&index=0&id=0ff9139c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff9139c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VAlert,VBtn,VCol,VIcon,VRow,VSelect})
